import dynamic from 'next/dynamic';
import SSOCallbackTastic from './padi-ui/sso-callback';
import { TasticRegistry } from './types';
const CategorySliderTastic = dynamic(() => import('./category-slider'));
const HeroTastic = dynamic(() => import('./content/hero'));
const Tile = dynamic(() => import('./content/tile'));
const TilesGroupTastic = dynamic(() => import('./content/tiles-group'));
const ContentSliderTastic = dynamic(() => import('./content-slider'));
const Footer = dynamic(() => import('./footer'));
const NotFoundTastic = dynamic(() => import('./not-found'));
const PadiDiveShopHeader = dynamic(() => import('./padi-dive-shop/dive-shop-header'));
const PadiProductAccordion = dynamic(() => import('./padi-product/accordion'));
const PadiSubscriptionAccordion = dynamic(() => import('./padi-product/accordion/subscription'));
const BundleTabs = dynamic(() => import('./padi-product/bundle-tabs'));
const PadiProductCtaAction = dynamic(() => import('./padi-product/cta-action'));
const PadiSubscriptionCtaAction = dynamic(() => import('./padi-product/cta-action/subscription'));
const ProductDescription = dynamic(() => import('./padi-product/description'));
const PadiProductFaqSection = dynamic(() => import('./padi-product/faq-section'));
const PadiProductFeatureSectionCheckList = dynamic(() => import('./padi-product/feature-section/check-list'));
const PadiSubscriptionFeatureSectionCheckList = dynamic(
  () => import('./padi-product/feature-section/check-list/subscription'),
);
const PadiProductFeatureSectionDynamicList = dynamic(() => import('./padi-product/feature-section/dynamic-list'));
const PadiProductSfmcNewsletterTastic = dynamic(() => import('./padi-product/form/sfmc-newsletter'));
const PadiProductHeaderSection = dynamic(() => import('./padi-product/header-section'));
const PadiSubscriptionHeaderSection = dynamic(() => import('./padi-product/header-section/subscription'));
const PadiProductStats = dynamic(() => import('./padi-product/stats'));
const PadiSubscriptionStats = dynamic(() => import('./padi-product/stats/subscription'));
const PadiRedeemReferralContent = dynamic(() => import('./padi-redeem-referral/redeem-content'));
const Accordion = dynamic(() => import('./padi-ui/accordion'));
const AlertTastic = dynamic(() => import('./padi-ui/alert'));
const AnnouncementBannerTastic = dynamic(() => import('./padi-ui/announcement-banner'));
const Bento33_33_33Tastic = dynamic(() => import('./padi-ui/bento-box/BentoBox-33-33-33'));
const Bento33_66Tastic = dynamic(() => import('./padi-ui/bento-box/BentoBox-33-66'));
const Bento5050Tastic = dynamic(() => import('./padi-ui/bento-box/BentoBox-50-50'));
const BreadcrumbsTastic = dynamic(() => import('./padi-ui/breadcrumbs'));
const CategoryPreviews = dynamic(() => import('./padi-ui/category-previews'));
const CrowdRiffTastic = dynamic(() => import('./padi-ui/crowdriff'));
const CtaTastic = dynamic(() => import('./padi-ui/cta'));
const CtaSectionTastic = dynamic(() => import('./padi-ui/cta-section'));
const CurrencySelector = dynamic(() => import('./padi-ui/currency-selector'));
const FaqSection = dynamic(() => import('./padi-ui/faq-section'));
const FeatureSectionCheckList = dynamic(() => import('./padi-ui/feature-section/check-list'));
const FeatureSectionDynamicList = dynamic(() => import('./padi-ui/feature-section/dynamic-list'));
const FooterTastic = dynamic(() => import('./padi-ui/footer'));
const SfmcNewsletterFormTastic = dynamic(() => import('./padi-ui/form/sfmc-newsletter'));
const PadiHeader = dynamic(() => import('./padi-ui/header'));
const HeaderTopbar = dynamic(() => import('./padi-ui/header/topbar'));
const HeaderSectionTastic = dynamic(() => import('./padi-ui/header-section'));
const PadiUiHeroTastic = dynamic(() => import('./padi-ui/hero'));
const HeroDestinationSearchTastic = dynamic(() => import('./padi-ui/hero-destination-search'));
const IncentivesTastic = dynamic(() => import('./padi-ui/incentives'));
const ListDescriptionTastic = dynamic(() => import('./padi-ui/list/description'));
const MenuFlyoutSimpleTastic = dynamic(() => import('./padi-ui/menu/flyout-simple'));
const MenuCard = dynamic(() => import('./padi-ui/menu/menu-card'));
const ProductFeaturesSplitImageTastic = dynamic(
  () => import('./padi-ui/product-features/product-features-split-image'),
);
const PromotionalTileTastic = dynamic(() => import('./padi-ui/promotional-tile'));
const PadiSimplifiedFooter = dynamic(() => import('./padi-ui/simplified-footer'));
const PadiSimplifiedHeader = dynamic(() => import('./padi-ui/simplified-header'));
const StatsTastic = dynamic(() => import('./padi-ui/stats'));
const TestimonialsTastic = dynamic(() => import('./padi-ui/testimonials'));
const VideoPlayerTastic = dynamic(() => import('./padi-ui/video-player'));
const ProductSlider = dynamic(() => import('./products/slider'));
const SpacerTastic = dynamic(() => import('./spacer'));

const Markdown = dynamic(() => import('./markdown'));
const AccountDetails = dynamic(() => import('./account/details'));
const AccountLogin = dynamic(() => import('./account/login'));
const Checkout = dynamic(() => import('./checkout'));
const ThankYou = dynamic(() => import('./thank-you'));
const ProductDetails = dynamic(() => import('./products/details'));
const ProductList = dynamic(() => import('./products/product-list'));
const SimilarProducts = dynamic(() => import('./products/similar-products'));
const OtherProducts = dynamic(() => import('./products/other-products'));
const Cart = dynamic(() => import('./cart'));
const PadiProductDetails = dynamic(() => import('./padi-product/details'));
const PadiProductList = dynamic(() => import('./padi-product/product-list'));
const PadiCertCardCatalog = dynamic(() => import('./padi-certification-cards/cert-card-catalog'));
const ReferralRedeemTastic = dynamic(() => import('./padi-ui/referral-redeem'));
const HeaderStarTastic = dynamic(() => import('./padi-ui/header-star'));
const MenuTabs = dynamic(() => import('./padi-ui/menu-tabs'));
const CardComparisonTastic = dynamic(() => import('./padi-ui/card-comparison'));
const ProductTileTastic = dynamic(() => import('./padi-ui/product-tile'));

export const tastics = {
  'commercetools/ui/checkout': Checkout,
  'commercetools/ui/thank-you': ThankYou,
  'commercetools/ui/footer': Footer,
  'commercetools/ui/content/tile': Tile,
  'commercetools/ui/content/hero': HeroTastic,
  'commercetools/ui/content/spacer': SpacerTastic,
  'commercetools/ui/content/markdown': Markdown,
  'commercetools/ui/cart': Cart,
  'commercetools/ui/products/details': ProductDetails,
  'commercetools/ui/products/product-list': ProductList,
  'commercetools/ui/products/slider': ProductSlider,
  'commercetools/ui/products/similar-products': SimilarProducts,
  'commercetools/ui/products/other-products': OtherProducts,
  'commercetools/ui/account/details': AccountDetails,
  'commercetools/ui/account/login': AccountLogin,
  'commercetools/ui/category-slider': CategorySliderTastic,
  'commercetools/ui/content/content-slider': ContentSliderTastic,
  'commercetools/ui/content/tiles-group': TilesGroupTastic,
  'commercetools/ui/not-found': NotFoundTastic,
  'padi-ui/header-section': HeaderSectionTastic,
  'padi-ui/product-features/product-features-split-image': ProductFeaturesSplitImageTastic,
  'padi-ui/menu/flyout-simple': MenuFlyoutSimpleTastic,
  'padi-ui/incentives': IncentivesTastic,
  'padi-ui/feature-section/dynamic-list': FeatureSectionDynamicList,
  'padi-ui/feature-section/check-list': FeatureSectionCheckList,
  'padi-ui/alert': AlertTastic,
  'padi-ui/faq-section': FaqSection,
  'padi-ui/cta-section': CtaSectionTastic,
  'padi-ui/list/description': ListDescriptionTastic,
  'padi-ui/form/sfmc-newsletter': SfmcNewsletterFormTastic,
  'padi-ui/footer': FooterTastic,
  'padi-product/description': ProductDescription,
  'padi-product/details': PadiProductDetails,
  'padi-product/cta-action': PadiProductCtaAction,
  'padi-product/cta-action/subscription': PadiSubscriptionCtaAction,
  'padi-product/feature-section/dynamic-list': PadiProductFeatureSectionDynamicList,
  'padi-product/feature-section/check-list': PadiProductFeatureSectionCheckList,
  'padi-product/feature-section/check-list/subscription': PadiSubscriptionFeatureSectionCheckList,
  'padi-product/faq-section': PadiProductFaqSection,
  'padi-product/header-section': PadiProductHeaderSection,
  'padi-product/header-section/subscription': PadiSubscriptionHeaderSection,
  'padi-product/stats': PadiProductStats,
  'padi-product/stats/subscription': PadiSubscriptionStats,
  'padi-ui/sso-callback': SSOCallbackTastic,
  'padi-ui/referral-redeem': ReferralRedeemTastic,
  'padi-dive-shop/dive-shop-header': PadiDiveShopHeader,
  'padi-ui/header/topbar': HeaderTopbar,
  'padi-ui/menu/menu-card': MenuCard,
  'padi-ui/currency-selector': CurrencySelector,
  'padi-ui/header': PadiHeader,
  'padi-ui/simplified-header': PadiSimplifiedHeader,
  'padi-ui/stats': StatsTastic,
  'padi-product/product-list': PadiProductList,
  'padi-certification-cards/cert-card-catalog': PadiCertCardCatalog,
  'padi-ui/accordion': Accordion,
  'padi-product/accordion': PadiProductAccordion,
  'padi-product/accordion/subscription': PadiSubscriptionAccordion,
  'padi-ui/testimonials': TestimonialsTastic,
  'padi-redeem-referral/redeem-content': PadiRedeemReferralContent,
  'padi-ui/simplified-footer': PadiSimplifiedFooter,
  'padi-ui/announcement-banner': AnnouncementBannerTastic,
  'padi-ui/category-previews': CategoryPreviews,
  'padi-ui/video-player': VideoPlayerTastic,
  'padi-ui/hero': PadiUiHeroTastic,
  'padi-product/bundle-tabs': BundleTabs,
  'padi-ui/promotional-tile': PromotionalTileTastic,
  'padi-ui/bento-33-66': Bento33_66Tastic,
  'padi-ui/bento-33-33-33': Bento33_33_33Tastic,
  'padi-ui/bento-50-50': Bento5050Tastic,
  'padi-ui/breadcrumbs': BreadcrumbsTastic,
  'padi-ui/cta': CtaTastic,
  'padi-product/form/sfmc-newsletter': PadiProductSfmcNewsletterTastic,
  'padi-ui/hero-destination-search': HeroDestinationSearchTastic,
  'padi-ui/crowdriff': CrowdRiffTastic,
  'padi-ui/card-comparison': CardComparisonTastic,
  'padi-ui/header-star': HeaderStarTastic,
  'padi-ui/menu-tabs': MenuTabs,
  'padi-ui/product-tile': ProductTileTastic,
} as TasticRegistry;
